export default "__VITE_ASSET__bc8bc8db__"